import React, { useMemo } from 'react';
// @ts-ignore
import styles from './CentralEvidenceSearchFieldItem.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import { CentralEvidenceSearchFieldValue } from './CentralEvidenceSearchField';
import { SearchItem } from '../../../Base/Types/utility.type';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import { joinClasses } from '../../../../Utils/className.util';

interface Props {
	item: SearchItem<CentralEvidenceSearchFieldValue>;
	selectOption: (value: { id: string; number?: string }) => void;
}

const CentralEvidenceSearchFieldItem: React.FC<Props> = ({
	item,
	selectOption,
}) => {
	const data = item?.data?.item;

	const handleSelect = () => {
		selectOption({
			id: data?.id,
			number: data?.number,
		});
	};

	const itemData: {
		title: string;
		birthNumber?: string;
		address?: string;
		phoneNumber?: string;
		relations?: string;
		age?: number;
		dateOfDeath?: string;
		archivedAt?: string;
	} = useMemo(() => {
		let relations = '';
		data?.userRelations?.forEach((item: any) => {
			relations +=
				item?.workplace?.name + ' - ' + item?.doctor?.fullName + '; ';
		});
		return {
			title: data?.number ? data.number : data?.fullName,
			birthNumber: data?.formattedBirthNumber,
			address: data?.formattedAddress,
			phoneNumber: data?.formattedPhoneNumber,
			age: data?.age,
			dateOfDeath: data?.dateOfDeath,
			archivedAt: data?.archivedAt,
			relations,
		};
	}, [data]);

	return (
		<div className={styles.wrapper} onClick={handleSelect}>
			<div className={styles.header}>
				<div
					className={joinClasses([
						styles.title,
						itemData.archivedAt ? styles.archived : '',
					])}>
					{itemData.title}
				</div>
				{itemData.archivedAt && (
					<div className={styles.dateOfDeath}>
						<Text tx='base.archived' inline />
						<FormattedMomentDate
							date={itemData.archivedAt}
							format={DateFormat.DATE}
						/>
					</div>
				)}
				{itemData.dateOfDeath && (
					<div className={styles.dateOfDeath}>
						<img
							className={styles.cross}
							src='/dist/icons/cross-sharp-solid.svg'
							alt='cross'
						/>
						<FormattedMomentDate
							date={itemData.dateOfDeath}
							format={DateFormat.DATE}
						/>
					</div>
				)}
			</div>
			<div className={styles.content}>
				{itemData?.birthNumber && (
					<div>
						<Text tx='base.shared.birthNumberShort' inline />:{' '}
						{itemData?.birthNumber}
					</div>
				)}
				{itemData?.age && (
					<div>
						{itemData?.age} <Text tx='base.years.many' inline />
					</div>
				)}
				{itemData?.address && <div>{itemData.address}</div>}
				{itemData?.phoneNumber && <div>{itemData.phoneNumber}</div>}
			</div>
			<div className={styles.content}>
				{itemData?.relations && <div>{itemData.relations}</div>}
			</div>
		</div>
	);
};

export default CentralEvidenceSearchFieldItem;
